import "./PrivacyPolicyPage.css";

export default function PrivacyPolicyPage() {
  return (
    <>
      <div className="container privacy-policy-container">
        <div className="row">
          <div className="col-lg-12">
            <div className="page-content mt-0">
              <h3 className="linear-text">Gizlilik Politikası</h3>
              <p>
                <strong>xPafy</strong> olarak, kullanıcılarımızın gizliliğine
                büyük önem veriyoruz. Bu Gizlilik Politikası, sitemizi ziyaret
                ettiğinizde kişisel bilgilerinizi nasıl işlediğimizi ve
                koruduğumuzu açıklamaktadır. <strong>xPafy</strong>, herhangi
                bir kişisel veri toplamaz ve kullanıcılar hakkında herhangi bir
                veri kaydetmez.
              </p>

              <h3 className="linear-text">Toplanan Veriler</h3>
              <p>
                <strong>xPafy</strong> üzerinden herhangi bir kişisel bilgi
                toplanmamaktadır. Kullanıcılarımızın kimlik bilgileri, iletişim
                bilgileri veya diğer kişisel verileri kesinlikle kaydedilmez.
              </p>

              <h3 className="linear-text">Çerezler (Cookies)</h3>
              <p>
                Sitemizi kullanırken, bazı anonim çerezler kullanılabilir. Bu
                çerezler, siteyi nasıl kullandığınızı anlamamıza yardımcı olur
                ve kullanıcı deneyimini iyileştirmek için kullanılır. Ancak, bu
                çerezler hiçbir şekilde kişisel bilgi toplamaz.
              </p>

              <h3 className="linear-text">Veri Paylaşımı</h3>
              <p>
                <strong>xPafy</strong> olarak, kullanıcıların kişisel verilerini
                hiçbir şekilde üçüncü şahıslarla paylaşmıyoruz veya satmıyoruz.
              </p>

              <h3 className="linear-text">Güvenlik</h3>
              <p>
                Sitenizden herhangi bir kişisel bilgi toplamadığımız için, veri
                güvenliği ile ilgili herhangi bir işlem yapılması
                gerekmemektedir. Ancak, sitemizin güvenliği için genel önlemler
                alınmaktadır.
              </p>

              <h3 className="linear-text">Üçüncü Taraf Bağlantılar</h3>
              <p>
                <strong>xPafy</strong> üzerindeki bazı bağlantılar, üçüncü taraf
                sitelerine yönlendirebilir. Bu sitelerin gizlilik
                politikalarından <strong>xPafy</strong> sorumlu değildir ve bu
                sitelerin gizlilik politikalarını okumanız önerilir.
              </p>

              <h3 className="linear-text">
                Gizlilik Politikası Değişiklikleri
              </h3>
              <p>
                Gizlilik politikamızda değişiklik yapma hakkımız saklıdır.
                Herhangi bir değişiklik olması durumunda, güncel politikayı bu
                sayfada yayınlayacağız.
              </p>

              <h3 className="linear-text">İletişim</h3>
              <p>
                Gizlilik politikamızla ilgili herhangi bir sorunuz varsa, lütfen
                bizimle iletişime geçin.
                <br />
                E-posta: <a href="mailto:info@xpafy.com">email@xpafy</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
